import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import {
  Layout,
  Breadcrumb,
  Form,
  Input,
  Table,
  List,
  Avatar,
  Button,
  message,
  Checkbox,
  Radio,
  Select,
} from 'antd';
import { SearchOutlined, CopyOutlined, FormOutlined } from '@ant-design/icons';
import _ from 'lodash';

import { API_HOST } from 'configs/env';

import whttp from 'libs/whttp';
import AppHelper from 'libs/AppHelper';
import { genFormItemAtrribute } from 'libs/FormHelper';

import DeleteConfirmButton from 'components/DeleteConfirmButton/DeleteConfirmButton';
import './styles.module.scss';

const FormItem = Form.Item;
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 };
export default class NewsList extends Component {
  formRef = React.createRef();

  state = {
    tableData: {
      current: 0, //目前頁數
      page_size: 10, //一頁幾筆
      total: 0, //以此query條件，總共幾筆資料
      rows: [],
    },
    tableQuery: {
      keyword: null,
      category_ids: [],
    },
    message: '',
    keyword: '',
    sort: '',
    is_middle_banner: null,
    promotion_status: 1,
    brandList: [],
    showBrandList: false,
  };

  componentDidMount() {
    AppHelper.updateConfig();
    this.loadCategoryData();
    this.loadData();
    this.fetchBrands();
  }

  fetchBrands = () => {
    whttp.get(
      `${API_HOST}/api/mgt/v1/brands`,
      {
        per_page: 10000,
      },
      (state, res) => {
        const { code = 100, reason = '發生錯誤', data = {} } = res;
        if (state === false) {
          return this.setState({ message: '發生錯誤' });
        }
        if (code !== 200) {
          return this.setState({ message: reason });
        }
        this.setState({ brandList: data.rows });
      }
    );
  };

  loadData = _.debounce((opt = { page: 1, page_size: 10 }) => {
    const tableQuery = this.formRef.current.getFieldValue();
    console.log('tableQuery', tableQuery);
    this.setState({ isLoadingData: true });
    whttp.get(
      `${API_HOST}/api/mgt/v1/news`,
      {
        page: _.get(opt, 'page', 1),
        page_size: _.get(opt, 'page_size', 10),
        keyword: tableQuery.keyword,
        sort: this.state.sort,
        category_ids: tableQuery.category_ids,
        is_middle_banner: this.state.is_middle_banner,
        promotion_status: this.state.promotion_status,
        brand_id: tableQuery.brand_id,
      },
      (state, res) => {
        this.setState({ isLoadingData: false });
        const { code = 100, reason = '發生錯誤', data = {} } = res;
        if (state === false) {
          return this.setState({ message: '發生錯誤' });
        }
        if (code !== 200) {
          return this.setState({ message: reason });
        }
        this.setState({ tableData: data });
      }
    );
  }, 200);

  deleteData = (item) => {
    if (_.isNil(item.id)) return;
    item.isDeleteData = true;
    this.setState({ isDeleteData: true });

    whttp.delete(API_HOST + `/api/mgt/v1/news/${item.id}`, {}, (state, res) => {
      item.isDeleteData = false;
      this.setState({ isDeleteData: false });
      const { code = 100, reason = '發生錯誤', data = {} } = res;

      if (state === false) {
        return message.error('發生錯誤');
      }

      if (code !== 200) {
        return message.error(reason);
      }

      message.success('刪除成功');

      this.loadData();
    });
  };

  cloneData = (item) => {
    if (_.isNil(item.id)) return;

    item.isCloneData = true;

    this.setState({ isCloneData: true });

    whttp.post(
      API_HOST + `/api/mgt/v1/news/${item.id}/clone`,
      {},
      (state, res) => {
        item.isCloneData = false;
        this.setState({ isCloneData: false });
        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false) {
          return message.error('發生錯誤');
        }

        if (code !== 200) {
          return message.error(reason);
        }

        message.success('複製成功');

        if (!_.isNil(data.id)) this.props.history.push(`/news/view/${data.id}`);
      }
    );
  };

  sortChange = (pagination, filters, sorter) => {
    let sort = '';
    if (!sorter) sort = '';
    else {
      let string = [];
      if (sorter.order) {
        string = sorter.order.split('end');
        sort = sorter.field + ' ' + string[0];
      } else {
        sort = '';
      }
      console.log(
        'pagination: ',
        pagination,
        'filters: ',
        filters,
        'sorter: ',
        sorter
      );
      console.log('sort = ', sort);
    }
    this.setState({ sort: sort }, () => this.loadData());
  };

  onCheckboxChange = (e) => {
    if (e.target.checked) this.setState({ is_middle_banner: 1 });
    else this.setState({ is_middle_banner: 0 });
  };

  onStatusChange = (e) => {
    this.setState({ promotion_status: e.target.value }, () => this.loadData());
  };

  //從網址判斷有沒有 category_id，再讓 checkbox 勾選帶回的參數
  loadCategoryData = () => {
    if (window.location.href.indexOf('?category_id') !== -1) {
      let category_id = AppHelper.getHashValue('category_id');
      category_id = category_id.split(',');
      for (let i = 0; i < category_id.length; i++) {
        category_id[i] = parseInt(category_id[i], 10);
      }
      this.formRef.current.setFields([
        {
          touched: true,
          validating: false,
          errors: [],
          name: ['category_ids'],
          value: category_id,
        },
      ]);
    }
  };

  handleChangeCategory = (checkedValue) => {
    console.log('checkedValue', checkedValue);
    let showBrandList = false;
    let resetBrandList = true;
    checkedValue.forEach((id) => {
      if ([129, 130].includes(id)) {
        showBrandList = true;
        resetBrandList = false;
      }
    });
    this.formRef.current.setFieldsValue({
      brand_id: resetBrandList
        ? null
        : this.formRef.current.getFieldValue('brand_id'),
    });
    this.setState({ showBrandList });
  };

  render() {
    const { tableData = {}, brandList, showBrandList } = this.state;
    const options = _.get(this, 'props.app.options', {});
    const newsCategories = options.news_categories || [];

    return (
      <Layout>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to={`/news`}>消息管理</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
        <h2>
          消息管理
          <span />
        </h2>
        <div className='block search'>
          <h3>
            搜尋
            <span />
          </h3>
          <Form
            ref={this.formRef}
            name='basic'
            className='basicForm'
            layout='vertical'
            initialValues={{
              promotion_status: this.state.promotion_status,
              brand_id: null,
            }}
            onFinish={(values) => {
              this.setState({ tableQuery: values });
              this.loadData(values);
              let category_ids = values.category_ids;
              localStorage.setItem('category_ids', category_ids);
            }}
          >
            <div className='flexBox col_12'>
              <FormItem {...genFormItemAtrribute('keyword', '名稱')}>
                <Input />
              </FormItem>
            </div>
            <Form.Item name='category_ids' label='消息類別'>
              <Checkbox.Group onChange={this.handleChangeCategory}>
                <List
                  grid={listGrid}
                  dataSource={newsCategories}
                  renderItem={(item) => (
                    <List.Item>
                      <Checkbox value={item.id}>{item.name}</Checkbox>
                    </List.Item>
                  )}
                />
              </Checkbox.Group>
            </Form.Item>
            {showBrandList && (
              <Form.Item name='brand_id' label='專屬品牌'>
                <Select
                  showSearch
                  filterOption={(input, option) => {
                    return option.children
                      .toUpperCase()
                      .includes(input.toUpperCase());
                  }}
                >
                  <Select.Option key='all' value={null}>
                    全部
                  </Select.Option>
                  {brandList.map((brand) => {
                    return (
                      <Select.Option key={brand.id} value={brand.id}>
                        {brand.name}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            )}
            <Form.Item name='others' label='其他'>
              <Checkbox onChange={this.onCheckboxChange}>
                中版位 Banner 是否啟用
              </Checkbox>
            </Form.Item>
            <Form.Item
              {...genFormItemAtrribute('promotion_status', '消息狀態')}
            >
              <Radio.Group onChange={this.onStatusChange}>
                <Radio.Button value={1}>全部</Radio.Button>
                <Radio.Button value={2}>上架中</Radio.Button>
                <Radio.Button value={3}>準備中</Radio.Button>
                <Radio.Button value={4}>已下架</Radio.Button>
              </Radio.Group>
            </Form.Item>
            <Form.Item style={{ textAlign: 'right' }}>
              <Button
                onClick={(event) => {
                  this.formRef.current.resetFields();
                  this.setState({ tableQuery: {} });
                  AppHelper.removeLocalStorage('category_ids');
                  this.loadData();
                }}
              >
                取消
              </Button>
              <Button
                type='primary'
                style={{ marginLeft: 8 }}
                icon={<SearchOutlined />}
                htmlType='submit'
              >
                搜尋
              </Button>
            </Form.Item>
          </Form>
        </div>
        <div className='toolbar'>
          <h3>
            消息列表
            <span />
          </h3>
          <Form layout='inline'>
            <Form.Item>
              <div className='flexBox'>
                <Link to={`/news/view`}>
                  <Button type='primary'>新增</Button>
                </Link>
              </div>
            </Form.Item>
          </Form>
        </div>
        <Table
          dataSource={tableData.rows}
          loading={this.state.isLoadingData}
          pagination={{
            current: _.get(tableData, 'current', []),
            total: _.get(tableData, 'total', 0),
            pageSize: _.get(tableData, 'page_size', 0),
            onChange: _.debounce((page, page_size) => {
              this.loadData({ page: page, page_size: page_size });
            }, 100),
          }}
          onChange={this.sortChange}
          columns={[
            { dataIndex: 'id', title: 'ID', sorter: (a, b) => a.id - b.id },
            {
              dataIndex: ['images', '0', 'url'],
              title: '圖片',
              render: (image) => (
                <Avatar
                  shape='square'
                  src={image}
                  component={
                    <div class='wp-menu-image dashicons-before dashicons-megaphone'>
                      <br />
                    </div>
                  }
                />
              ),
            },
            {
              dataIndex: 'name',
              key: 'id',
              title: '名稱',
              sorter: (a, b) => a.name.length - b.name.length,
            },
            { dataIndex: 'category_name', title: '分類' },
            { dataIndex: 'status_name', title: '狀態' },
            {
              dataIndex: 'modified_at',
              title: '更新時間',
              sorter: (a, b) => a.modified_at - b.modified_at,
            },
            { dataIndex: ['modified_user', 'name'], title: '異動者' },
            {
              title: 'Action',
              key: 'tools',
              width: 250,
              render: (text, record) => (
                <List
                  grid={{ gutter: 4, column: 3 }}
                  dataSource={[
                    <DeleteConfirmButton
                      loading={record.isDeleteData === true}
                      size='small'
                      onConfirm={() => this.deleteData(record)}
                    />,
                    <Button
                      type='default'
                      size='small'
                      icon={<CopyOutlined />}
                      loading={record.isCloneData === true}
                      onClick={() => this.cloneData(record)}
                    >
                      複製
                    </Button>,
                    <Link role='button' to={`/news/view/${record.id}`}>
                      <Button
                        type='default'
                        size='small'
                        icon={<FormOutlined />}
                      >
                        編輯
                      </Button>
                    </Link>,
                  ]}
                  renderItem={(item) => <List.Item>{item}</List.Item>}
                />
              ),
            },
          ]}
        />
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/News/NewsList.js